import React, { useState, useEffect } from 'react'
import { useAuth } from './hooks/useAuth'
import { supabase } from './lib/supabase'
import AuthPage from './pages/AuthPage'
import Dashboard from './pages/Dashboard'
import TrendsPage from './pages/TrendsPage'
import ProfilePage from './pages/ProfilePage'
import CoachPage from './pages/CoachPage'
import HabitsSettingsPage from './pages/HabitsSettingsPage'
import WeeklyReportPage from './pages/WeeklyReportPage'
import LifeAreaPage from './pages/LifeAreaPage'
import HealthPage from './pages/HealthPage'
import JournalPage from './pages/JournalPage'
import FitnessPage from './pages/FitnessPage'
import FriendsPage from './pages/FriendsPage'
import InsightsPage from './pages/InsightsPage'
import AddGoalPage from './pages/AddGoalPage'

function AppContent() {
  const { user, profile, loading } = useAuth()
  const [page, setPage] = useState('dashboard')
  const [selectedArea, setSelectedArea] = useState(null)
  const [trialExpired, setTrialExpired] = useState(false)

  useEffect(() => {
    if (profile) checkTrial()
  }, [profile])

  function checkTrial() {
    if (!profile?.trial_start) return
    if (profile?.is_pro && profile?.onboarding_complete) {
      // Check if 5-day trial has expired (only matters if not a paid subscriber)
      const trialStart = new Date(profile.trial_start)
      const trialEnd = new Date(trialStart.getTime() + 5 * 24 * 60 * 60 * 1000)
      const now = new Date()
      // For now we just flag it — actual payment handling comes with IAP
      if (now > trialEnd) setTrialExpired(true)
    }
  }

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#111118', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '24px', letterSpacing: '4px', color: '#c9a84c' }}>LIFESCORE</div>
    </div>
  )

  if (!user) return <AuthPage />

  function navigate(p, extra) { setPage(p); if (extra) setSelectedArea(extra) }

  // Trial expired — send to profile to upgrade
  if (trialExpired && page !== 'profile') {
    return <ProfilePage onNavigate={navigate} trialExpired={true} />
  }

  return (
    <>
      {page === 'trends'   && <TrendsPage onNavigate={navigate} />}
      {page === 'coach'    && <CoachPage onNavigate={navigate} />}
      {page === 'profile'  && <ProfilePage onNavigate={navigate} />}
      {page === 'habits'   && <HabitsSettingsPage onNavigate={navigate} />}
      {page === 'weekly'   && <WeeklyReportPage onNavigate={navigate} />}
      {page === 'fitness'  && <FitnessPage onNavigate={navigate} />}
      {page === 'friends'  && <FriendsPage onNavigate={navigate} />}
      {page === 'insights' && <InsightsPage onNavigate={navigate} />}
      {page === 'addgoal' && <AddGoalPage onNavigate={navigate} />}
      {page === 'area'     && <LifeAreaPage area={selectedArea} onNavigate={navigate} />}
      {page === 'health'   && <HealthPage onNavigate={navigate} />}
      {page === 'journal'  && <JournalPage onNavigate={navigate} />}
      {page === 'dashboard' && <Dashboard onNavigate={navigate} />}
    </>
  )
}

export default function App() {
  return <AppContent />
}
